import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class SecurityPolicy extends BaseComponent {
	
	constructor() {
		super();
		
		var securityPolicy = this;
		setTimeout(function(){
			securityPolicy.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var securityPolicy = this;
		
		var formPanel = ElementUtil.create({
			tag: 'dl-form-panel',
			itemid: 'form',
			children: [
				{
					tag: 'vaadin-form-layout',
					children: [
						{
							tag: 'fieldset',
							colspan: 2,
							children: [
								{
									tag: 'legend',
									innerHTML: 'Login Handling'
								},
								{
									tag: 'vaadin-checkbox',									
									name: 'autoApproveUsers',
									label: 'Auto Approve User'
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-number-field',	
									label: 'Minimum Password Length',
									name: 'minPasswordLength',
									style: 'min-width: 250px;',
									required: true,
									max: 255,
									min: 6									
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-number-field',	
									label: 'Max Login Attempt',
									name: 'loginLockoutMaxAttempts',
									style: 'min-width: 250px;',
									required: true,
									max: 100,
									min: 1									
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-number-field',	
									label: 'Reset Lockout Timeout Minutes',
									name: 'resetLockoutTimeMinutes',
									style: 'min-width: 250px;',
									required: true,
									max: 999999,
									min: 1									
								},
								{
									tag: 'br'
								},								
								{
									tag: 'vaadin-checkbox',									
									name: 'requireAdminUnlock',
									label: 'Require Admin to Unlock'
								}
							]
						},
						{
							tag: 'fieldset',
							style: 'margin-top: 20px;',
							colspan: 2,
							children: [
								{
									tag: 'legend',
									innerHTML: 'API Handling'
								},
								{
									tag: 'vaadin-checkbox',									
									name: 'allowJSONPSupport',
									label: 'Allow JSON P Support'			
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-text-area',
									label: 'CORS Origins',
									name: 'corsOrigins',
									style: 'width: 250px; max-height: 150px',									
									maxlength: 4096
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-text-area',
									label: 'CORS Methods',
									name: 'corsMethods',
									style: 'width: 250px; max-height: 150px',									
									maxlength: 4096
								},
								{
									tag: 'br'
								},
								{
									tag: 'vaadin-text-area',
									label: 'CORS Headers',
									name: 'corsHeaders',
									style: 'width: 250px; max-height: 150px',									
									maxlength: 4096
								},
								{	
									tag: 'br'
								},
								{
									tag: 'vaadin-text-area',
									label: 'Custom Headers',
									name: 'customHeaders',
									style: 'width: 250px; max-height: 150px',									
									maxlength: 4096
								}								
							]
						}
					]
				}, 
				{
					tag: 'vaadin-button',
					theme: 'primary',
					style: 'margin-top: 20px;',
					children: [
						ElementUtil.makeIcon('vaadin:database', ' Save')
					],
					listeners: {
						click: function() {
							
							formPanel.submitForm({
								actualCall: function(data) {
									return Service.getSecurityService().savePolicy(data);
								},
								success: function(data, responseData) {
									window.DL.MessageUtil.showToast('Success', 'Updated Policy', {
										theme: 'success',
										position: 'top-stretch'
									});	
								}
							});	
							
						}
					}
				}
			]
		});
								
		securityPolicy.append(formPanel);
		
		var loadMask = formPanel.showLoading();
		Service.getSecurityService().getPolicy().then(function(policy){
			loadMask.remove();
			formPanel.load(policy);
		});
		
		
	}
	
};
customElements.define('dl-security-policy-form', SecurityPolicy);

